export const GET_TRAINER = 'GET_TRAINER'
export const GET_RACES_BY_TRAINER = 'GET_RACES_BY_TRAINER'
export const GET_RACE = 'GET_RACE'
export const GET_RACE_TYPES = 'GET_RACE_TYPES'
export const GET_QUESTION_BY_RACE = 'GET_QUESTION_BY_RACE'
export const GET_ANSWER_BY_RACE_QUESTION = 'GET_ANSWER_BY_RACE_QUESTION'
export const START_RACE = 'START_RACE'
export const FINISH_RACE = 'FINISH_RACE'
export const GET_RUNNERS_BY_RACE = 'GET_RUNNERS_BY_RACE'
export const DELETE_RACE = 'DELETE_RACE'
export const ADD_TASK_TO_QUEUE = 'ADD_TASK_TO_QUEUE'
export const REMOVE_TASK_FROM_QUEUE = 'REMOVE_TASK_FROM_QUEUE'
export const SET_IS_TRAINER  = 'SET_IS_TRAINER'
export const GET_QUOTE_BY_RACE = 'GET_QUOTE_BY_RACE'
export const SET_ALERT = 'SET_ALERT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js